<template>
  <div class="content relative-top">
    <font-awesome-icon
      icon="chevron-right"
      class="link-icon"
    />
    <a
      href="https://business.bt.com/be-more/#secure"
      target="blank"
    >
      {{ $t('dashboard.common.more_info') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'AcronisPanel',
  inheritAttrs: false
}
</script>
